import React from "react";

// Elegant photography placeholder — warm cinematic block with grain.
// Intentionally NOT an AI-generated food image. To be replaced with real photography.
export const Placeholder = ({
  variant = "warm",
  ratio = "4/5",
  label,
  className = "",
  children,
  ...rest
}) => {
  const variants = {
    warm: "placeholder-warm",
    cool: "placeholder-cool",
    bone: "placeholder-bone",
  };
  return (
    <div
      data-testid="photo-placeholder"
      className={`relative overflow-hidden ${variants[variant]} ${className}`}
      style={{ aspectRatio: ratio }}
      {...rest}
    >
      {label && (
        <div
          className={`absolute inset-0 flex items-end justify-between p-5 sm:p-7 ${
            variant === "bone" ? "text-ink/60" : "text-bone/55"
          }`}
        >
          <span className="font-mono text-[10px] tracking-wider3 uppercase">
            {label}
          </span>
          <span className="font-mono text-[10px] tracking-wider3 uppercase">
            Photography
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default Placeholder;
